import * as React from "react";

export interface IResourceLoaderProps<T> {
  load: () => Promise<T>;
  children: (loaded: boolean, resource: T) => JSX.Element;
}

export function ResourceLoader<T>({ load, children }: IResourceLoaderProps<T>) {
  const [resource, setResource] = React.useState<T>(null);
  React.useEffect(
    () => {
      let isSubscribed = true;
      load().then(r => {
        if (isSubscribed) {
          setResource(r);
        }
      });
      return () => {
        isSubscribed = false;
      };
    },
    [load]
  );
  return children(resource !== null, resource);
}
